import { loader } from "~/root";
import Footer from "./Footer";
import Nav from "./Nav";
import { useRouteLoaderData } from "@remix-run/react";
import { NavLogoConstruction } from "~/assets/svgs/logos/NavLogoConstruction";
import { NavLogoMining } from "~/assets/svgs/logos/NavLogoMining";
import { NavLogoEnergy } from "~/assets/svgs/logos/NavLogoEnergy";
import { NavLogoManufacturing } from "~/assets/svgs/logos/NavLogoManufacturing";
import { NavLogoNational } from "~/assets/svgs/logos/NavLogoNational";
import { NavLogoNorthAmerica } from "~/assets/svgs/logos/NavLogoNorthAmerica";
import Progress from "./Progress";

export const Layout = ({ children }: { children: React.ReactNode }) => {
  const data = useRouteLoaderData<typeof loader>("root");

  const navLogos = {
    Construction: NavLogoConstruction,
    National: NavLogoNational,
    Mining: NavLogoMining,
    Energy: NavLogoEnergy,
    Manufacturing: NavLogoManufacturing,
    NorthAmerica: NavLogoNorthAmerica,
  };

  if (!data) {
    throw new Error("Data is required");
  }

  const { footer, header, microcopy, settings, mailingListForm } = data;

  const siteTheme = data.siteTheme as keyof typeof navLogos;

  const helpline = settings.data.contacts?.find(
    (contact) => contact.slug?.current === "helpline",
  );
  const email = settings.data.contacts?.find(
    (contact) => contact.slug?.current === "email",
  );
  const marqueeText = microcopy.data.find(
    (item) => item.slug?.current === "footer-marquee",
  )?.text;

  return (
    <>
      <Progress />
      <Nav
        data={header.data}
        // NavLogo={navLogos[siteTheme]}
        NavLogo={navLogos["NorthAmerica"]}
        helpline={helpline}
        socials={settings.data.socials}
      />
      {/* <Search /> */}
      <main>{children}</main>
      <Footer
        data={footer.data}
        copyright={settings.data.copyright}
        links={settings.data.footerLinks}
        helpline={helpline}
        email={email}
        donateLink={settings.data.donateLink}
        marqueeText={marqueeText}
        socials={settings.data.socials}
        mailingList={settings.data?.mailingList}
        foundingIndustryPartner={settings.data.foundingIndustryPartner}
        mailingListForm={mailingListForm}
      />
    </>
  );
};
